import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import "./ProductDetails.css";
var styles = { "productDetails": "eed2a5", "northstar-small": "a1c5d0", "northstar-large": "cb6020", "inner": "b86b62", "hm": "ec329a", "row": "a4d8ee", "leftColumn": "dd258a" };
import AvailabilityMarker from '../AvailabilityMarker';
import ComparativePrice from '../ComparativePrice';
import MarketingMarker from '../MarketingMarker';
import NewProductMarker from '../NewProductMarker';
import PriorPrice from '../PriorPrice';
import ProductClubPrice from '../ProductClubPrice';
import ProductPrice from '../ProductPrice';
import ProductSwatches from '../ProductSwatches';
import ProductTitle from '../ProductTitle';
const ProductDetails = (_a) => {
    var { comparativePrice, variant = 'hm' } = _a, props = __rest(_a, ["comparativePrice", "variant"]);
    return (React.createElement("div", { className: cn(styles.productDetails, styles[variant]) },
        React.createElement("div", { className: cn(styles.inner, styles[variant]) }, variant === 'northstar-large' ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.row },
                React.createElement(ProductTitle, Object.assign({ variant: variant }, props)),
                React.createElement(ProductPrice, Object.assign({ variant: variant }, props))),
            React.createElement("div", { className: styles.row },
                React.createElement("div", { className: styles.leftColumn },
                    React.createElement(ProductClubPrice, Object.assign({ variant: variant }, props)),
                    React.createElement(PriorPrice, Object.assign({ variant: variant }, props)),
                    comparativePrice && React.createElement(ComparativePrice, Object.assign({ variant: variant }, comparativePrice)),
                    React.createElement(MarketingMarker, Object.assign({ variant: variant }, props)),
                    React.createElement(NewProductMarker, Object.assign({ variant: variant }, props)),
                    React.createElement(AvailabilityMarker, Object.assign({ variant: variant }, props))),
                React.createElement("div", null,
                    React.createElement(ProductSwatches, Object.assign({ variant: variant }, props)))))) : (React.createElement(React.Fragment, null,
            React.createElement(ProductTitle, Object.assign({ variant: variant }, props)),
            React.createElement(ProductPrice, Object.assign({ variant: variant }, props)),
            React.createElement(ProductClubPrice, Object.assign({ variant: variant }, props)),
            React.createElement(PriorPrice, Object.assign({ variant: variant }, props)),
            comparativePrice && React.createElement(ComparativePrice, Object.assign({ variant: variant }, comparativePrice)),
            React.createElement(MarketingMarker, Object.assign({ variant: variant }, props)),
            React.createElement(ProductSwatches, Object.assign({ variant: variant }, props)),
            React.createElement(NewProductMarker, Object.assign({ variant: variant }, props)),
            React.createElement(AvailabilityMarker, Object.assign({ variant: variant }, props)))))));
};
export default ProductDetails;
//# sourceMappingURL=ProductDetails.js.map